import { fromJS } from 'immutable';

import {
  GET_JOBS,
  GET_JOBS_SUCCESS,
  GET_JOBS_FAILURE,
  CREATE_JOB,
  CREATE_JOB_SUCCESS,
  CREATE_JOB_FAILURE,
  UPDATE_JOB,
  UPDATE_JOB_SUCCESS,
  UPDATE_JOB_FAILURE,
  RESET_JOBS_STATE,
} from '../actions/actionTypes';
import { JOB_STATUS_CODES } from '../../constants';

const initialState = fromJS({
  jobs: [],
  isLoading: false,
  jobsRetrieved: false,
  error: null,
  jobsCount: {
    [JOB_STATUS_CODES.STATUS_01]: 0, // status code 1 is 'New - Action Required'
    [JOB_STATUS_CODES.STATUS_02]: 0, // status code 2 is 'Customer Contacted'
    [JOB_STATUS_CODES.STATUS_03]: 0, // status code 3 is 'Tender Successful'
    [JOB_STATUS_CODES.STATUS_04]: 0, // status code 3 is 'Not Progressing - Archive'
  },
  isCreatingJob: false,
  isUpdatingJob: false,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_JOBS:
      return state.set('isLoading', true).set('error', null);
    case GET_JOBS_SUCCESS: {
      const statusCode01Jobs = action.jobs.filter(
        job => job.status.code === JOB_STATUS_CODES.STATUS_01,
      );
      const statusCode02Jobs = action.jobs.filter(
        job => job.status.code === JOB_STATUS_CODES.STATUS_02,
      );
      const statusCode03Jobs = action.jobs.filter(
        job => job.status.code === JOB_STATUS_CODES.STATUS_03,
      );
      const statusCode04Jobs = action.jobs.filter(
        job => job.status.code === JOB_STATUS_CODES.STATUS_04,
      );
      return state
        .set('isLoading', false)
        .set('jobsRetrieved', true)
        .set('error')
        .set('jobs', fromJS(action.jobs))
        .set(
          'jobsCount',
          fromJS({
            [JOB_STATUS_CODES.STATUS_01]: statusCode01Jobs.length,
            [JOB_STATUS_CODES.STATUS_02]: statusCode02Jobs.length,
            [JOB_STATUS_CODES.STATUS_03]: statusCode03Jobs.length,
            [JOB_STATUS_CODES.STATUS_04]: statusCode04Jobs.length,
          }),
        );
    }
    case GET_JOBS_FAILURE:
      return state
        .set('isLoading', false)
        .set('jobsRetrieved', false)
        .set('error', fromJS({ message: action.errMsg }));
    case CREATE_JOB:
      return state.set('isCreatingJob', true).set('error', null);
    case CREATE_JOB_SUCCESS:
      return state
        .update('jobs', jobs => jobs.push(fromJS(action.job)))
        .updateIn(
          ['jobsCount', JOB_STATUS_CODES.STATUS_01.toString()],
          value => value + 1,
        )
        .set('isCreatingJob', false)
        .set('error');
    case CREATE_JOB_FAILURE:
      return state
        .set('isCreatingJob', false)
        .set('error', fromJS({ message: action.errMsg }));
    case UPDATE_JOB:
      return state.set('isUpdatingJob', true).set('error', null);
    case UPDATE_JOB_SUCCESS: {
      // Things that need to be done here include:
      // 1. get the job with old data
      // 2. get the the old status code of the job
      // 3. replace the job with the updated job in the jobs list
      // 4. decrement the jobsCount of the old status by 1
      // 5. increment the jobsCount of the new status by 1
      // 6. set 'isUpdatingJob' flag to false
      const oldJob = state
        .get('jobs')
        .find(job => job.get('id') === action.job.id);
      const oldStatusCode = oldJob.getIn(['status', 'code']);
      const updatedJobsList = state
        .get('jobs')
        .filter(job => job.get('id') !== action.job.id)
        .push(fromJS(action.job));
      return state
        .set('jobs', updatedJobsList)
        .updateIn(['jobsCount', oldStatusCode.toString()], value => value - 1)
        .updateIn(
          ['jobsCount', action.job.status.code.toString()],
          value => value + 1,
        )
        .set('isUpdatingJob', false);
    }
    case UPDATE_JOB_FAILURE:
      return state
        .set('isUpdatingJob', false)
        .set('error', fromJS({ message: action.errMsg }));
    case RESET_JOBS_STATE:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
